// extracted by mini-css-extract-plugin
export var profile = "styles-module__profile___GjQxy";